import { Button as Button } from 'bootstrap';
import '@fortawesome/fontawesome-free/css/all.css';

import Swiper from 'swiper';
import { Autoplay, Pagination, Navigation, EffectFade, EffectCreative, Scrollbar } from 'swiper/modules';
Swiper.use([Autoplay, Pagination, Navigation, EffectFade, EffectCreative, Scrollbar]);
import "swiper/swiper-bundle.css";

import Rellax from "rellax";

import AOS from "aos";
import "aos/dist/aos.css";

import './styles.scss';


document.addEventListener("DOMContentLoaded", function () {
  window.addEventListener("scroll", function () {
    if (window.scrollY > 60) {
      document.getElementById("header").classList.add("scrolled");
    } else {
      document.getElementById("header").classList.remove("scrolled");
    }
  });
});

const appHeight = () => {
  const doc = document.documentElement;
  doc.style.setProperty("--app-height", `${window.innerHeight}px`);
};
window.addEventListener("resize", appHeight);
appHeight();

$( document ).ready( function() {
  if (window.location.hash) {
    var target = window.location.hash;
  }

  $( 'body' ).addClass( 'active' );

  if (window.location.hash) {
    var target = window.location.hash;
    $("html, body").animate({ scrollTop: $(target).offset().top - 88 }, 300);
  }


  $(".menu-toggle").on("click touch", function (e) {
    e.preventDefault();
    $(this).toggleClass("active");
    $(this).parent("a").parent("li").find(".sub-menu").first().slideToggle(300);
  });

  $(".header-main li a").on( 'click touch', function() {
    $("header").removeClass("open");
    $(".burger .burger-button").removeClass("active");
    $(".header-main").removeClass("active");
    $("body").removeClass("menu-open");
  })


  $(".burger .burger-button").on("click touch", function (e) {
    e.preventDefault();
    $("header").toggleClass("open");

    $(".burger .burger-button").toggleClass("active");
    $(".header-main").toggleClass("active");
    $("body").toggleClass("menu-open");
  });

  $(".header-main-pattern,.close-button").on("click touch", function (e) {
    e.preventDefault();
    $("header").removeClass("open");
    $(".burger .burger-button").removeClass("active");
    $(".header-main").removeClass("active");
    $("body").removeClass("menu-open");
  });

  $(function () {
    $('.current-menu-item a[href*="#"]:not([href="#"])').click(function () {
      if (
        location.pathname.replace(/^\//, "") ==
          this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        if (target.length) {
          setTimeout(function () {
            $("html, body").animate(
              { scrollTop: $(target).offset().top - 0 },
              0
            );
          }, 200);
          return false;
        }
      }
    });
  });

  $(".arrow").on("click touch", function (e) {
    e.preventDefault();
    var target = $(this).attr("href");
    if ($(target).length > 0) {
      $("html, body").animate({ scrollTop: $(target).offset().top - 100 }, 0);
      return false;
    } else {
      $("html, body").animate({ scrollTop: $("#footer").offset().top - 100 }, 0);
      return false;
    }
  });


  $( '.header-logo').on( 'mouseenter', function() {
    var img = $( this ).find( 'img' ).data( 'gif' );
    if( !$( this ).hasClass( 'played' ) ) {
      $( this ).find( 'img' ).attr( 'src', img );
      $( this ).addClass( 'played' );
    }
  })

  var splitBlockSwiper = new Swiper(".split_only_block .swiper", {
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 1000,
    loop: false,
    autoHeight: true,
    direction: "horizontal",
    observer: true,
    observeParents: true,
    /*autoplay: {
      delay: 5000,
    },*/
    /*pagination: {
      el: ".split_block .swiper-pagination",
      type: "bullets",
      clickable: true,
    },*/
    /*
    effect: "creative",
    creativeEffect: {
      prev: {
        translate: ["-20%", 0, -1],
      },
      next: {
        translate: ["100%", 0, 0],
      },
    },*/
    navigation: {
      nextEl: ".split_only_block .swiper-button-next",
      prevEl: ".split_only_block .swiper-button-prev",
    },
    breakpoints: {
      992: {
        //direction: "vertical",
        autoHeight: false,
      },
    },
  });

  splitBlockSwiper.on( 'slideChange', function() {
    var index = splitBlockSwiper.realIndex + 1;
    $(".split_only_block .image.active" ).removeClass( 'active' );
    $(".split_only_block .image-" + index ).addClass( 'active' );
  });

  var splitProjectBlockSwiper = new Swiper(".split_projects_block .swiper", {
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 1000,
    loop: false,
    autoHeight: true,
    direction: "horizontal",
    observer: true,
    observeParents: true,
    /*autoplay: {
      delay: 5000,
    },*/
    /*pagination: {
      el: ".split_block .swiper-pagination",
      type: "bullets",
      clickable: true,
    },*/
    /*
    effect: "creative",
    creativeEffect: {
      prev: {
        translate: ["-20%", 0, -1],
      },
      next: {
        translate: ["100%", 0, 0],
      },
    },
    */
    navigation: {
      nextEl: ".split_projects_block .swiper-button-next",
      prevEl: ".split_projects_block .swiper-button-prev",
    },
    breakpoints: {
      992: {
        //direction: "vertical",
        autoHeight: false,
      },
    },
  });

  splitProjectBlockSwiper.on("slideChange", function () {
    var index = splitProjectBlockSwiper.realIndex + 1;
    $(".split_projects_block .image.active").removeClass("active");
    $(".split_projects_block .image-" + index).addClass("active");
  });


  $(".split_only_block .swiper-slide h2").on( 'click touch', function(e) {
    e.preventDefault();
    var search = $( this ).text().split(",");

    var target = $('.split_projects_block .swiper-slide:contains("' + search[0] + '")');


    $( 'main' ).addClass( 'scrolled' );

    console.log( target );

    splitProjectBlockSwiper.slideTo( target.index(), 0 );

  });

  $(".split_projects_block .swiper-slide .title h2").on("click touch", function (e) {
    e.preventDefault();
    var search = $(this).text();

    $("main").removeClass("scrolled");

  });

  $( 'body' ).on( 'click touch', '.read-more', function(e) {
    e.preventDefault();
    $(this).parents(".split-container").find(".read-more-container").fadeIn(500);
    setTimeout(function () {
      splitBlockSwiper.update();
    }, 500);
  });

  $( 'body' ).on( 'click touch', '.close', function(e) {
    e.preventDefault();
    $(this).parents(".split-container").find(".read-more-container").fadeOut(500);
    setTimeout( function() {
      splitBlockSwiper.update();
      $(this).trigger("resize");
    }, 800);
  });


  $("body").on("click touch", ".logout", function (e) {
    //console.log(ajax_logout_object);
    $.ajax({
      type: "POST",
      url: myAjax.ajaxurl,
      data: {
        action: "ajaxlogout"
      },
      success: function (data) {
        window.location.replace(myAjax.homeurl);
      },
      error: function (xhr, status, error) {
        var err = eval("(" + xhr.responseText + ")");
        alert(err.Message);
      },
    });
    e.preventDefault();
  });


  $("form#login").on("submit", function (e) {
    $("form#login .message").empty().hide(300);
    $.ajax({
      type: "POST",
      dataType: "json",
      url: myAjax.ajaxurl,
      data: {
        action: "ajaxlogin", //calls wp_ajax_nopriv_ajaxlogin
        username: $("form#login #user").val(),
        password: $("form#login #password").val()
      },
      success: function (data) {
        $("form#login .message").text(data.message);
        if (data.loggedin == true) {
          window.location.replace(myAjax.redirecturl);
        } else {
          $( 'form#login .message' ).text( data.message ).show(300);
        }
      },
      error: function (xhr, status, error) {
        var err = eval("(" + xhr.responseText + ")");
        alert(err.Message);
      },
    });
    e.preventDefault();
  });



  AOS.init({
    offset: 60, // offset (in px) from the original trigger point
    delay: 0, // values from 0 to 3000, with step 50ms
    duration: 900, // values from 0 to 3000, with step 50ms
    easing: "ease", // default easing for AOS animations
    once: true, // whether animation should happen only once - while scrolling down
  });

});